/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react';

import type { StepComponentProps } from 'components/Stepper';

export const isElement = (element: unknown): element is Element =>
  element instanceof Element;

export const useRefSize = (
  ref: React.RefObject<HTMLElement>,
  target?: keyof HTMLElement
): number => {
  const [size, setSize] = useState(0);

  useEffect(() => {
    if (ref?.current) {
      const refElement = target ? ref.current[target] : ref.current;
      const clientHeight = isElement(refElement) ? refElement.clientHeight : 0;
      const clientWidth = isElement(refElement) ? refElement.clientWidth : 0;
      setSize(Math.min(clientHeight, clientWidth));
    }
  }, [ref, target]);

  return size;
};

export const useUpdateValidation = (
  updateValidation: StepComponentProps['updateValidation'],
  isValid: boolean
): void => {
  useEffect(
    () => updateValidation && updateValidation(isValid),
    [isValid, updateValidation]
  );
};
